module.exports = __webpack_public_path__ + "img/A3-8-plan.389e6b38.png";